// @flow

import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import type { Element } from 'react';

import { faTrash, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { withTranslation } from '@i18n';

import type { GlobalState } from '@globalTypes';
import { SECONDARY_BUTTON, PRIMARY_BUTTON } from '../StatefulButton/constants';
import type { Props } from './types';

import { dismissConfirmation } from './redux/actions';

import Dialog from '../Dialog';
import StatefulButton from '../StatefulButton';
import { RESPONSE_CANCELLED, RESPONSE_CONFIRMED, CONFIRM_DELETE } from './redux/constants';

import {
  StyledIcon,
  StyledContent,
  StyledTitle,
  StyledDescriptionText,
  StyledButtonsWrapper
} from './styles';

const ConfirmationDialog = ({
  confirmationDialog,
  dismissConfirmation,
  t
}: Props): Element<any> => {
  if (!confirmationDialog.visible) return <></>;

  const keyPrefix = confirmationDialog.kind === CONFIRM_DELETE
    ? 'ConfirmationDialog.Delete'
    : 'ConfirmationDialog.Default';

  return (
    <Dialog size="SMALL">
      <Dialog.DialogContent>
        <StyledContent>
          <StyledIcon icon={confirmationDialog.kind === CONFIRM_DELETE ? faTrash : faInfoCircle} />

          <StyledTitle>{t(`${keyPrefix}.Title`)}</StyledTitle>
          <StyledDescriptionText>{t(`${keyPrefix}.Description`)}</StyledDescriptionText>
        </StyledContent>
      </Dialog.DialogContent>
      <Dialog.DialogFooter>
        <StyledButtonsWrapper>
          <StatefulButton
            buttonType={SECONDARY_BUTTON}
            label={t(`${keyPrefix}.Cancel`)}
            onClick={() => dismissConfirmation(RESPONSE_CANCELLED)}
          />

          <StatefulButton
            buttonType={PRIMARY_BUTTON}
            label={t(`${keyPrefix}.Confirm`)}
            onClick={() => dismissConfirmation(RESPONSE_CONFIRMED)}
          />
        </StyledButtonsWrapper>
      </Dialog.DialogFooter>
    </Dialog>
  );
};

const mapStateToProps = (state: GlobalState) => ({
  confirmationDialog: state.confirmationDialog
});

const mapDispatchToProps = { dismissConfirmation };

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withTranslation(['common'])
)(ConfirmationDialog);
